var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('monitoring', {
    attrs: {
      "setCurrentSubjectId": _vm.setCurrentSubjectId,
      "currentSubjectId": _vm.currentSubjectId,
      "loading": _vm.pending,
      "sort": _vm.sort,
      "records": _vm.paginatedRecords,
      "events": _vm.events,
      "total": _vm.totalRecords,
      "display": _vm.display,
      "show": _vm.showModal,
      "page": _vm.page
    },
    on: {
      "search": _vm.search,
      "paginate": _vm.setPage,
      "sort": _vm.setSort
    }
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f7062b4e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/monitoring/MonitoringContainer.vue
// module id = 899
// module chunks = 0